export default __webpack_public_path__ + "static/media/sensitiveinfo.0cc3284f.svg";